import PageLayout from "@/components/layout/PageLayout";
import HowItWorks from "@/components/sections/HowItWorks";

export default function ProcessPage() {
  return (
    <PageLayout testId="process-page">
      <HowItWorks />
    </PageLayout>
  );
}
